import { render, staticRenderFns } from "./AppStatsIcon.vue?vue&type=template&id=5509387c"
import script from "./AppStatsIcon.vue?vue&type=script&lang=js"
export * from "./AppStatsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports